module.exports = require("connect-redis");


//////////////////
// WEBPACK FOOTER
// external "connect-redis"
// module id = 39
// module chunks = 0